// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"d7475b8325f2d48e","6394":"4dfa2e3f2030ae9f"}[chunkId] + ".css";
};